// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/Users/Swizec/Documents/random-coding/useAuth/examples/useauth-gatsby/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-auth-0-callback-js": () => import("/Users/Swizec/Documents/random-coding/useAuth/examples/useauth-gatsby/src/pages/auth0_callback.js" /* webpackChunkName: "component---src-pages-auth-0-callback-js" */),
  "component---src-pages-index-js": () => import("/Users/Swizec/Documents/random-coding/useAuth/examples/useauth-gatsby/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-page-2-js": () => import("/Users/Swizec/Documents/random-coding/useAuth/examples/useauth-gatsby/src/pages/page-2.js" /* webpackChunkName: "component---src-pages-page-2-js" */)
}

